import PROXY_CONFIG from "../../Config/ProxyConfig";
import Legend from "assets/PrixImmobilier/prix_immobilier_legend.json";

const colors = [
  "#14bc01",
  "#16c702",
  "#76e302",
  "#abe302",
  "#deff05",
  "#fff832",
  "#ffe82f",
  "#ffd502",
  "#ffa51f",
  "#ff7a14",
  "#ff0900",
  "#c80000",
];
const CreateLegend = async (properties) => {

  let province = properties.province;
  let max_legend = null;
  let min_legend = null;
  let number_colors_legend = null;
  return new Promise((resolve, reject) => {
    if (!province) {
      max_legend = Legend["all"].max;
      min_legend = Legend["all"].min;
      number_colors_legend = Legend["all"].number_colors_legend;
    } else {

      max_legend = Legend[province].max;
      min_legend = Legend[province].min;
      number_colors_legend = Legend[province].number_colors_legend;
    }




    if (!max_legend || !min_legend || !number_colors_legend) {
      reject([]);
    } else {

      let total_difference = max_legend - min_legend;
      let legend = [parseInt(min_legend)];
      for (let i = 0; i < 12; i++) {
        legend = legend.concat(parseInt(legend[i] + total_difference / 11));
        if (legend.length == 12) {
          resolve(legend);
        }
      }
    }
  });
};

export default CreateLegend;
